import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {Subscription} from 'rxjs';
import {PaywallService} from '@core/services/limits/paywall.service';
import {PaymentFacadeService} from '@core/services/entities/payment/payment-facade.service';
import {PaywallModalComponent} from '../paywall-modal/paywall-modal.component';

/**
 * Невидимый компонент, слушающий PaywallService и открывающий MatDialog с модалкой.
 * Монтируется в корневом layout, чтобы быть активным на любой странице.
 */
@Component({
  selector: 'paywall-host',
  template: '',
})
export class PaywallHostComponent implements OnInit, OnDestroy {
  private sub = new Subscription();

  constructor(
    private paywall: PaywallService,
    private dialog: MatDialog,
    private facade: PaymentFacadeService,
  ) {
  }

  ngOnInit(): void {
    this.sub.add(
      this.paywall.open$.subscribe(payload => {
        const ref = this.dialog.open(PaywallModalComponent, {data: payload, panelClass: 'paywall-dialog'});
        ref.afterClosed().subscribe(result => {
          if (result?.invoiceId && result.paymentType === 'invoice') {
            window.open(this.facade.pdfUrl(result.invoiceId), '_blank');
          }
        });
      })
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
